import { render, staticRenderFns } from "./PriceByHoleDividerPopup.vue?vue&type=template&id=606017f3&"
import script from "./PriceByHoleDividerPopup.vue?vue&type=script&lang=js&"
export * from "./PriceByHoleDividerPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports